export const icons = {
    settings: 'fas fa-cog',
    support: 'fas fa-headset',
    dashboard: 'fas fa-desktop',
    organisations: 'fas fa-building',
    network: 'fas fa-users',
    address: 'fas fa-map-marked-alt',
    timezone: 'fas fa-clock',
    tva: 'fas fa-id-card-alt',
    taxRegistrationNumber: 'fas fa-trademark',
    cnssAffiliation: 'fas fa-hand-holding',
    commercialRegister: 'fas fa-copyright',
    WebSite: 'fas fa-at',
    activityArea: 'fas fa-briefcase',
    typePack: 'fas fa-cube',
    pricePack: 'fas fa-dollar-sign',
    subscriptionPeriod: 'fa fa-hourglass-start',
    trialPeriod: 'far fa-hourglass',
    numberOfHoursOfSupport: 'fa fa-headphones',
    numberOfUsers: 'fa fa-users',
    functionality: 'fas fa-file',
    detailsFunctionality: 'fas fa-file-alt',
    module: 'fas fa-folder-open',
    url: 'fas fa-globe',
    order: 'fas fa-sort-amount-up-alt',
    firstName: 'fas fa-user',
    email: 'fas fa-envelope',
    society: 'fa fa-building',
    user: 'fa fa-user',
    phone: 'fa fa-phone',
    country: 'fa fa-flag',
    currency: 'fas fa-money-bill-alt',
    language: 'fas fa-globe',
    check: 'fas fa-check',
    password: 'fas fa-key',
    postalCode: 'fas fa-map-marker-alt',
    city: 'fas fa-route',
    additionalAddress: 'fas fa-map-signs',
    numSIRET: 'fas fa-hand-holding-usd',
    logs: 'fa fa-history'
};
